export default __webpack_public_path__ + "static/media/New_logo.5e832286.png";